import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
	ProgramQuestionInterface,
	SessionDetailFormInterface,
	SessionFeedbackAnswerInterface,
	SessionFeedbackFormInterface,
} from '../../components/feedback/SessionFeedback';

const initialAnswers = {
	sessionDetailForm: {},
	sessionFeedbackForm: {},
} as SessionFeedbackAnswerInterface;

export const feedbackFormSlice = createSlice({
	name: 'feedbackForm',
	initialState: null as number | null,
	reducers: {
		setFeedbackFormInFocus: (_state, action: PayloadAction<number | null>) => action.payload,
	},
});

export const feedbackQuestionSlice = createSlice({
	name: 'feedbackQuestions',
	initialState: [] as ProgramQuestionInterface[],
	reducers: {
		setFeedbackQuestions: (_state, action: PayloadAction<ProgramQuestionInterface[]>) => action.payload,
	},
});

export const feedbackAnswerSlice = createSlice({
	name: 'feedbackAnswers',
	initialState: initialAnswers,
	reducers: {
		updateSessionDetail: (state, action: PayloadAction<SessionDetailFormInterface>) => {
			state.sessionDetailForm = { ...state.sessionDetailForm, ...action.payload };
		},
		updateSessionFeedback: (state, action: PayloadAction<SessionFeedbackFormInterface>) => {
			state.sessionFeedbackForm = { ...state.sessionFeedbackForm, ...action.payload };
		},
		resetSessionFeedback: () => initialAnswers,
	},
});
